<template>
  <div
    id="orderDeliveryModal"
    class="modal fade"
  >
    <div
      id="print-area"
      class="modal-dialog modal-full"
    >
      <div class="modal-content">
        <!-- style="border-style: dashed; border-width: 1px" -->
        <div class="modal-header">
          <button
            id="close-button"
            type="button"
            class="close"
            @click="closeModal('orderDeliveryModal')"
          >
            &times;
          </button>
        </div>

        <table
          style="width: 100%"
          id="head-table"
        >
          <tr>
            <td style="width: 130px;" class="print-pl-20">
              <img
                style="width: 110px; height: 100px"
                id="header-img"
                src="../../../assets/images/black_shipzone.png"
                alt=""
              />
            </td>
            <td>
              <table
                id="company-info"
                style="width: 100%;" class="print-ml-0"
              >
                <tr class="header-table">
                  <td style="font-size: 14px; font-weight: bold;" class="print-pr-20">
                    {{ companyData.company_name }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-20">
                    {{ companyData.company_address }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-20">
                    {{ companyData.company_email }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-20">
                    {{ companyData.phone_number }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <div class="modal-body mx-2">
          <table
            style="width: 100%; margin-top: 10px;"
            id="print-table1"
          >
            <tr>
              <td style="text-align: center; padding: 8px 0;">
                <strong style="font-size: 22px; text-transform: uppercase;">{{ $t('delivery.orderDeliveryInvoiceTitle') }}</strong>
              </td>
            </tr>
          </table>

          <table style="width: 100%; margin-bottom: 10px; border: 1px solid #000;" id="print-table2">
            <tr>
              <td style="padding: 10px; width: 50%; vertical-align: top; border-right: 1px solid #000;">
                <p style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('columns.invoiceNumber') }}:</strong>
                  <span> {{ viewData.invoice_number }}</span>
                </p>
                <p style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('columns.status') }}:</strong>
                  <span> {{ statusLabel(viewData.status) }}</span>
                </p>
                <p v-if="viewData.note" style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('columns.note') }}:</strong>
                  <span style="background-color: #FFF9C4; padding: 2px 6px; border-radius: 3px; -webkit-print-color-adjust: exact; print-color-adjust: exact; color-adjust: exact;"> {{ viewData.note }}</span>
                </p>
              </td>
              <td style="padding: 10px; width: 50%; vertical-align: top;">
                <p style="font-size: 14px; font-weight: bold; margin: 0 0 6px 0; text-decoration: underline;">{{ $t('delivery.invoicedToLabel') }}</p>
                <p style="font-size: 14px; margin: 3px 0; font-weight: bold; background-color: yellow; color: black; display: inline-block; -webkit-print-color-adjust: exact; print-color-adjust: exact; color-adjust: exact;">
                  {{ viewData.resolved_customer.full_name }}
                </p>
                <p v-if="invoiceAddressText" style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('columns.address') }}:</strong> {{ invoiceAddressText }}
                </p>
                <p style="font-size: 14px; margin: 3px 0;">
                  {{ $t('columns.phone') }}: {{ viewData.resolved_customer.phone_number }}
                </p>
                <p v-if="viewData.resolved_customer.phone_number_2" style="font-size: 14px; margin: 3px 0;">
                  {{ $t('delivery.phone2Label') }}: {{ viewData.resolved_customer.phone_number_2 }}
                </p>
              </td>
            </tr>
          </table>

          <div
            v-if="viewData.order_invoices && viewData.order_invoices.length"
            class="print-scroll-x"
          >
          <table
            style="width: 100%; min-width: 650px; border-collapse: collapse; border: 1px solid #000;"
          >
            <thead>
              <tr style="background-color: #f2f2f2; font-size: 13px;">
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">#</th>
                <th style="border: 1px solid #000; padding: 6px;">{{ $t('columns.invoiceNo') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">{{ $t('invoice.ordersLabel') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">{{ $t('reports.paymentStatus') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: right;">{{ $t('columns.totalPrice') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: right;">{{ $t('reports.paid') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: right;">{{ $t('columns.remaining') }}</th>
                <th
                  v-if="$_has_perm('detach_order_delivery_invoice')"
                  class="no-print"
                  style="border: 1px solid #000; padding: 6px; text-align: center;"
                >{{ $t('columns.actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(invoice, index) in viewData.order_invoices">
                <tr :key="'summary-' + invoice.order_invoice_id" style="font-size: 13px;">
                  <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ index + 1 }}</td>
                  <td style="border: 1px solid #000; padding: 5px;">{{ invoice.invoice_number }}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ (invoice.orders || []).length }}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: center;">
                    <span
                      :style="{ backgroundColor: paymentStatusColor(invoice.payment_status, invoice.edit_count).bg, color: paymentStatusColor(invoice.payment_status, invoice.edit_count).color, padding: '2px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold', display: 'inline-block' }"
                    >{{ paymentStatusLabel(invoice.payment_status) }}</span>
                  </td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: right;">$ {{ invoiceTotalUsd(invoice).toFixed(2) }}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: right;">$ {{ Number(invoice.paid_amount || 0).toFixed(2) }}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: right;">$ {{ Number(invoice.remaining_amount || 0).toFixed(2) }}</td>
                  <td
                    v-if="$_has_perm('detach_order_delivery_invoice')"
                    class="no-print"
                    style="border: 1px solid #000; padding: 5px; text-align: center;"
                  >
                    <a
                      :tooltip="$t('delivery.detachTooltip')"
                      style="color:#c62828; cursor:pointer;"
                      @click="detachInvoice(invoice)"
                    >
                      <i class="fa fa-unlink" />
                    </a>
                  </td>
                </tr>
                <tr :key="'detail-' + invoice.order_invoice_id" style="font-size: 12px;">
                  <td
                    :colspan="$_has_perm('detach_order_delivery_invoice') ? 8 : 7"
                    style="border: 1px solid #000; padding: 6px; background-color: #fafafa;"
                  >
                    <div class="print-scroll-x">
                    <table style="width: 100%; min-width: 480px; border-collapse: collapse;">
                      <thead>
                        <tr style="color: #616161;">
                          <th style="padding: 3px 5px; border-bottom: 1px solid #ccc;" class="text-align-left">{{ $t('delivery.orderNumberColumn') }}</th>
                          <th style="padding: 3px 5px; border-bottom: 1px solid #ccc;" class="text-align-left">{{ $t('columns.productName') }}</th>
                          <th style="padding: 3px 5px; text-align: center; border-bottom: 1px solid #ccc;">{{ $t('columns.size') }}</th>
                          <th style="padding: 3px 5px; text-align: right; border-bottom: 1px solid #ccc;">{{ $t('columns.price') }}</th>
                          <th style="padding: 3px 5px; text-align: center; border-bottom: 1px solid #ccc;">{{ $t('columns.qty') }}</th>
                          <th style="padding: 3px 5px; text-align: right; border-bottom: 1px solid #ccc;">{{ $t('columns.total') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="order in invoice.orders" :key="order.order_id">
                          <td style="padding: 3px 5px;">{{ order.theOrderID }}</td>
                          <td style="padding: 3px 5px;">{{ order.product_name }}</td>
                          <td style="padding: 3px 5px; text-align: center;">{{ order.size }}</td>
                          <td style="padding: 3px 5px; text-align: right;">$ {{ orderUnitPriceCombined(order).toFixed(2) }}</td>
                          <td style="padding: 3px 5px; text-align: center;">{{ order.quantity }}</td>
                          <td style="padding: 3px 5px; text-align: right;">$ {{ orderLineTotalCombined(order).toFixed(2) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          </div>

          <table
            style="width: 100%; border-collapse: collapse; margin-top: 0; table-layout: fixed;"
          >
            <colgroup>
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <tr v-if="allInvoicedOrders.length" style="font-size: 15px; font-weight: bold;">
              <td style="border: 1px solid #000; padding: 6px 8px;">{{ $t('delivery.totalOrdersLabel') }}</td>
              <td style="border: 1px solid #000; padding: 6px 8px; text-align: right;">{{ allInvoicedOrders.length }}</td>
            </tr>
            <tr v-if="viewData.order_invoices && viewData.order_invoices.length" style="font-size: 15px; font-weight: bold;">
              <td style="border: 1px solid #000; padding: 6px 8px;">{{ $t('delivery.totalUsdLabel') }}</td>
              <td style="border: 1px solid #000; padding: 6px 8px; text-align: right;"><span style="background-color: yellow; color: black; -webkit-print-color-adjust: exact; print-color-adjust: exact; color-adjust: exact;">$ {{ totalUsd }}</span></td>
            </tr>
            <tr v-if="viewData.order_invoices && viewData.order_invoices.length" style="font-size: 15px; font-weight: bold;">
              <td style="border: 1px solid #000; padding: 6px 8px;">{{ $t('delivery.iraqiDinarLabel') }}</td>
              <td style="border: 1px solid #000; padding: 6px 8px; text-align: right;">{{ totalIqd }} IQD</td>
            </tr>
            <tr style="font-size: 15px; font-weight: bold;">
              <td style="border: 1px solid #000; padding: 6px 8px;">{{ $t('columns.deliveryPrice') }}:</td>
              <td style="border: 1px solid #000; padding: 6px 8px; text-align: right;">{{ formatIQD(viewData.delivery_price) }} IQD</td>
            </tr>
            <tr style="font-size: 15px; font-weight: bold;">
              <td style="border: 1px solid #000; padding: 6px 8px;">{{ $t('delivery.totalIqdColonLabel') }}</td>
              <td style="border: 1px solid #000; padding: 6px 8px; text-align: right;"><span style="background-color: yellow; color: black; -webkit-print-color-adjust: exact; print-color-adjust: exact; color-adjust: exact;">{{ grandTotalIqd }} IQD</span></td>
            </tr>
          </table>

          <table
            v-if="viewData.direct_orders && viewData.direct_orders.length"
            style="width: 100%; border-collapse: collapse; border: 1px solid #000; margin-top: 16px;"
          >
            <thead>
              <tr style="background-color: #f2f2f2; font-size: 13px;">
                <th style="border: 1px solid #000; padding: 6px; text-align: center;" colspan="2">{{ $t('delivery.attachedOrdersNotYetInvoiced') }}</th>
              </tr>
              <tr style="background-color: #f2f2f2; font-size: 13px;">
                <th style="border: 1px solid #000; padding: 6px;">{{ $t('delivery.orderColumn') }}</th>
                <th style="border: 1px solid #000; padding: 6px;">{{ $t('delivery.productColumn') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="order in viewData.direct_orders" :key="order.order_id" style="font-size: 13px;">
                <td style="border: 1px solid #000; padding: 5px;">{{ order.theOrderID }}</td>
                <td style="border: 1px solid #000; padding: 5px;">{{ order.product_name }}</td>
              </tr>
            </tbody>
          </table>

          <div style="margin-top: 10px;" class="print-float-right">
            <v-btn
              @click="printInvoice"
              id="print-button"
              style="height:auto"
              outline
              color="primary"
            >{{ $t('printLogs.printButton') }}</v-btn>
          </div>
        </div>

        <!-- PRINTABLE TABLEs -->
        <!-- <table
          id="head-table"
          style="padding-top: 30px; width: 100%"
          class="show-in-print"
        >
          <tr>
            <td class="print-pl-20">
              <img
                style="width: 110px; height: 100px"
                id="header-img"
                src="../../../assets/images/black_shipzone.png"
                alt=""
              />
            </td>
            <td>
              <table
                id="company-info"
                style="width: 100%;" class="print-ml-0"
              >
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-10">
                    {{ companyData.company_name }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-10">
                    {{ companyData.company_address }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-10">
                    {{ companyData.company_email }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-10">
                    {{ companyData.phone_number }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <div class="modal-body show-in-print">
          <table
            style="width: 100%"
            id="print-table1"
          >
            <tr>
              <td id="credit-table-header">
                <strong style="font-size: 20px">
                  Order Delivery Invoice
                </strong>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%"
            id="print-table2"
          >
            <tr>
              <td >
                Customer Name
              </td>
              <td >
                {{ viewData.order.customer.full_name }}
              </td>
            </tr>
            <tr>
              <td >
                Customer Phone
              </td>
              <td >
                {{ viewData.order.customer.phone_number }}
              </td>
            </tr>
            <tr>
              <td >
                Address
              </td>
              <td >
                {{ viewData.order.customer.address }}
              </td>
            </tr>
            <tr>
              <td >
                Delivery Price
              </td>
              <td >
                {{ viewData.delivery_price }}
              </td>
            </tr>
          </table>
        </div> -->

        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import { roundUpIqd } from '../../mixins/helpers'

export default {
  props: ['viewData', 'closeModal', 'companyData'],

  data() {
    return {
      exRate: 1
    }
  },

  mounted() {
    let theModal = document.querySelector('.modal')
    theModal.style.overflowX = 'auto'
    $('.show-in-print').hide()

    const token = localStorage.getItem('access_token')
    axios
      .get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } })
      .then((res) => {
        this.exRate = res.data ? res.data.ex_rate || 1 : 1
      })
      .catch(() => {})
  },

  computed: {
    // Every order across every attached invoice, flattened for the item-level breakdown table —
    // each order already carries its own product_name/size/item_price/quantity/total_amount
    // from OrderDeliveryController::show()'s orderInvoices.orders eager-load (no select()
    // restriction, so every Order column is present, same as OrderInvoiceDocument.vue's own
    // invoiceData.orders). Tagged with its parent invoice_number here (lost once flattened)
    // so the breakdown table can show which attached invoice each order belongs to — more than
    // one invoice can be attached to the same delivery request.
    allInvoicedOrders() {
      const invoices = this.viewData.order_invoices || []
      return invoices.reduce((all, invoice) => {
        const tagged = (invoice.orders || []).map((order) => ({ ...order, _invoiceNumber: invoice.invoice_number }))
        return all.concat(tagged)
      }, [])
    },

    // Customer's selected/default mobile delivery address, formatted the same way as
    // ViewCustomerDeliveryInvoice.vue/prepareToPrint.vue.
    defaultAddressText() {
      const addr = this.viewData.resolved_customer && this.viewData.resolved_customer.selected_address
      if (!addr) return ''
      const parts = [addr.label, addr.area, addr.street, addr.building_name, addr.additional_directions].filter(Boolean)
      return parts.length > 0 ? parts.join(', ') : (addr.name || '')
    },

    // Customer's profile address (governorate/city/address entered when the customer was
    // created/edited) — same fields/composition as orderDeliveries.vue's profileAddress().
    profileAddressText() {
      const customer = this.viewData.resolved_customer || {}
      const parts = [
        customer.governorate && customer.governorate.governorate_name,
        customer.city && customer.city.city_name,
        customer.address
      ].filter(Boolean)
      return parts.join(', ')
    },

    // What's actually shown on the invoice — the selected default mobile location, or the
    // customer's profile address when no default location has been selected.
    invoiceAddressText() {
      return this.defaultAddressText || this.profileAddressText
    },

    // Total USD actually owed across every attached shipping invoice — a paid (or canceled)
    // invoice contributes nothing (already settled), a not-paid one contributes its full
    // amount, and a partial-paid one contributes only what's still remaining. This is what
    // still needs to be collected on delivery, not the invoices' raw combined value.
    totalUsd() {
      const invoices = this.viewData.order_invoices || []
      const sum = invoices.reduce((total, invoice) => total + this.invoiceAmountOwed(invoice), 0)
      return sum.toFixed(2)
    },
    totalIqdRaw() {
      const raw = Number(this.totalUsd) * Number(this.exRate)
      return roundUpIqd(raw)
    },
    totalIqd() {
      return this.totalIqdRaw.toLocaleString()
    },
    // IRAQI DINAR (shipping invoices total) + Delivery Price, both in IQD.
    grandTotalIqd() {
      const deliveryPriceIqd = this.formatIQD(this.viewData.delivery_price)
      return (this.totalIqdRaw + deliveryPriceIqd).toLocaleString()
    }
  },

  methods: {
    formatIQD(value) {
      return Math.round(Number(value) || 0)
    },

    invoiceTotalUsd(invoice) {
      const val = Number(invoice.discount) > 0 ? invoice.net_price : invoice.total_price
      return Number(val || 0)
    },

    // Same two calculations as OrderInvoiceDocument.vue's (Shipping Invoice) Items Table, so the
    // per-order detail row here matches exactly.
    /** Per-unit USD: item_price + internal_shipping_handling (int. ship. hidden from its own row). */
    orderUnitPriceCombined(order) {
      return Number(order.item_price || 0) + Number(order.internal_shipping_handling || 0)
    },
    // The order's own total_amount is the actual charged amount — NOT unit price × quantity.
    // Those can diverge (e.g. after an "Edit Charge" correction, or when other fees are folded
    // into total_amount), so this must read total_amount directly rather than recomputing it.
    orderLineTotalCombined(order) {
      return Number(order.total_amount || 0)
    },

    // Paid/canceled invoices are already settled — nothing left to collect on delivery.
    // Partial-paid contributes only what's still owed; not-paid contributes its full amount.
    invoiceAmountOwed(invoice) {
      if (invoice.payment_status === 'paid' || invoice.payment_status === 'cancel') {
        return 0
      }
      if (invoice.payment_status === 'partial_paid') {
        return Number(invoice.remaining_amount || 0)
      }
      return this.invoiceTotalUsd(invoice)
    },

    detachInvoice(invoice) {
      swal({
        title: this.$t('delivery.detachConfirmTitle'),
        text: this.$t('delivery.detachConfirmText', { invoice: invoice.invoice_number }),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((confirmed) => {
        if (!confirmed) return

        const token = localStorage.getItem('access_token')
        axios
          .post('api/order-delivery/detach-invoice', {
            order_delivery_id: this.viewData.order_delivery_id,
            order_invoice_id: invoice.order_invoice_id
          }, { headers: { Authorization: 'Bearer ' + token } })
          .then((response) => {
            this.$emit('detached')
            swal({ text: response.data.message, icon: 'success', timer: 1500, buttons: false })
          })
          .catch((err) => {
            const msg = (err.response && err.response.data && err.response.data.message)
              ? err.response.data.message
              : this.$t('invoice.somethingWentWrong')
            swal({ text: msg, icon: 'error' })
          })
      })
    },

    // Same badge colors as orderInvoices.vue's statusColor(), for consistency with the
    // shipping invoice view.
    paymentStatusColor(status, editCount) {
      if (status === 'not_paid' && !Number(editCount)) {
        return { bg: '#E0E0E0', color: '#616161' }
      }

      const map = {
        // Matches the "Invoiced To" customer name highlight further up this same view
        // (background-color: yellow; color: black) — this dialog only, per request.
        not_paid: { bg: 'yellow', color: 'black' },
        partial_paid: { bg: '#FFC85C', color: '#6B4C00' },
        paid: { bg: '#89D7B7', color: '#1A5940' },
        cancel: { bg: '#FB8C00', color: '#FFFFFF' }
      }
      return map[status] || { bg: '#F5F5F5', color: '#616161' }
    },

    paymentStatusLabel(status) {
      const map = {
        not_paid: this.$t('invoice.unpaidStatus'),
        partial_paid: this.$t('invoice.partialPaidStatus'),
        paid: this.$t('invoice.paidStatus'),
        cancel: this.$t('invoice.cancelStatus')
      }
      return map[status] || (status ? status.replace(/_/g, ' ') : '')
    },

    // Same codes as orderDeliveries.vue's statusList -- viewData.status_name from the
    // API is always English, so this maps the numeric code through $t() instead.
    statusLabel(status) {
      const map = {
        1: this.$t('orders.pendingStatus'),
        2: this.$t('orders.cancelTooltip'),
        3: this.$t('orders.sentStatusTitle'),
        4: this.$t('orders.receivedStatusTitle'),
        5: this.$t('delivery.postStatus'),
        6: this.$t('delivery.holdStatus')
      }
      return map[status] || ''
    },

    printInvoice() {
      $('#close-button').hide()
      $('#print-button').hide()
      $('.no-print').hide()
      $('.show-in-print').show()

      $('#print-area').printMe({ path: this.$_print_stylesheet_paths() })

      $('#close-button').show()
      $('#print-button').show()
      $('.no-print').show()
      $('.show-in-print').hide()
    }
  }
}
</script>

<style>
#print-area {
  max-width: 850px;
}

/* Keeps wide tables from forcing the whole page/viewport wider than the phone screen on
   mobile — without this, a table with more columns than fit a phone's width stretches its
   ancestors, so the browser renders (and prints) the entire page at a larger effective size
   than the device, which looks like being "zoomed in" and can't be fixed by pinch-zooming
   out (that only shrinks everything uniformly, it doesn't reflow the layout narrower). Only
   the table itself scrolls horizontally within its own box; the rest of the page stays sized
   to the viewport. Printing still needs the full table, not just the visible scrolled slice,
   so overflow is reset to visible under @media print. */
.print-scroll-x {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
@media print {
  .print-scroll-x {
    overflow: visible !important;
  }
}

.modal {
  text-align: center;
  padding: 0 !important;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

@media screen and (max-width: 650px) {
  #credit-table-header {
    width: 500px;
    padding-left: 10px;
  }
  #price-section2 {
    width: 500px;
    padding-left: 10px;
    padding-top: 10px;
    font-size: 15px;
  }
  #price-section {
    width: 280px;
  }
  #company-info {
    width: 100%;
  }
  #header-img {
    width: 60px;
    height: 60px;
  }
  #print-area {
    max-width: 100%;
  }

  /* Bootstrap's vertical-centering trick above (.modal:before + .modal-dialog's
     vertical-align: middle) centers short dialogs fine, but once this dialog's content is
     taller than the phone screen, centering an oversized box pushes its top below the
     viewport's top edge — you have to scroll past dead space just to reach the start of the
     invoice. Below this breakpoint, drop the centering and let the dialog flow from the top
     like a normal scrollable page instead. Scoped to this modal's own ids so other dialogs
     elsewhere in the app (this <style> block is unscoped) keep their centered behavior. */
  #orderDeliveryModal:before {
    display: none;
  }
  #orderDeliveryModal #print-area {
    display: block;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderDelivery/orderDeliveryInvoice.vue